import { useAuth } from "../auth/AuthContext";
import { listTaxRates } from "../api/taxRatesApi";
import { useAsyncData } from "../lib/useAsyncData";

export function useTaxRateOptions() {
  const { ensureFreshToken } = useAuth();
  return useAsyncData(() => ensureFreshToken().then((token) => listTaxRates(token, { activeOnly: true })), []);
}

export interface TaxRateSelectProps {
  id: string;
  label: string;
  value: string;
  onChange: (taxRateId: string) => void;
  required?: boolean;
}

/** `GET /tax-rates?active_only=true`-backed dropdown — used by the product create/edit
 * form (§13.1). Always optional: `InventoryItem.tax_rate_id` is nullable and falls back to
 * the tenant's/branch's default `TaxRate` at sale time when unset
 * (`app/services/tax_service.py`). */
export function TaxRateSelect({ id, label, value, onChange, required }: TaxRateSelectProps) {
  const taxRatesState = useTaxRateOptions();
  const taxRates = taxRatesState.data ?? [];

  return (
    <div className="sl-field">
      <label className="sl-field__label" htmlFor={id}>
        {label}
      </label>
      <select
        id={id}
        className="sl-input"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        required={required}
        disabled={taxRatesState.loading}
      >
        <option value="">Use branch/tenant default</option>
        {taxRates.map((rate) => (
          <option key={rate.id} value={rate.id}>
            {rate.name} — {rate.rate_percent}% ({rate.is_inclusive ? "inclusive" : "exclusive"})
          </option>
        ))}
      </select>
      {taxRatesState.error ? <p className="sl-field__error">{taxRatesState.error}</p> : null}
    </div>
  );
}
